import { useState, useEffect } from "react";
import { HandySvg } from "handy-svg";
import iconCart from "../../assets/icons/svg-sprite/cart.svg";
import iconDeleteCross from "../../assets/icons/svg-sprite/delete-cross--round.svg";
import iconPointerRight from "../../assets/icons/svg-sprite/point-arrow-right.svg";
import cartPickerReinit from "../../modules/cart-picker-reinit";
import { cards } from "../../lib/api/api";

const CartPicker = ({
  ID,
  subscriptions,
  selectedPackages,
  setSelectedPackages,
  setConnectedPackages,
  changeMessage,
}) => {
  const [amount, setAmount] = useState(0);

  useEffect(() => {
    cartPickerReinit();
    let sum = 0;
    selectedPackages.forEach((item) => {
      sum += Number(item.price.rubles);
    });
    setAmount(sum);
  }, [selectedPackages]);

  useEffect(() => {
    if (ID !== null) {
      submitForm();
    }
  }, [ID]);

  function submitForm() {
    const formElement = document.getElementById("cart-picker");
    formElement.addEventListener("submit", (e) => {
      e.preventDefault();
      const formData = new FormData(formElement);
      const selectionItems = formData.getAll("service_code");
      setSelectedPackages([]);
      const banner = document.getElementById("messageBanner");
      banner.style.removeProperty("display");
      selectionItems.forEach((item) => {
        cards
          .connectSubscription(ID, item)
          .then(() => {
            setConnectedPackages((prevState) => ({
              ...prevState,
              [item]: true,
            }));
            const name = subscriptions.filter(
              (elem) => elem.billing_service_code == item
            );
            changeMessage(
              `Заявка на изменение подписки ${name[0].name} успешно создана!`
            );
          })
          .catch((err) => {
            changeMessage("Ошибка подключения, попробуйте позже");
            console.log(err);
          });
      });
    });
  }

  return (
    <>
      <div
        className={
          "cart-picker" +
          (selectedPackages.length === 0 ? " cart-picker--hidden" : "")
        }
      >
        <form
          id="cart-picker"
          className="cart-picker__inner page-container"
          method="POST"
        >
          <div className="cart-picker__cart-btn">
            <div
              className="cart-btn cart-btn--cart-picker"
              data-count={selectedPackages.length}
            >
              <HandySvg
                className="svg-icon cart-btn__icon"
                src={iconCart}
                width="24"
                height="24"
              />
            </div>
          </div>
          <div className="cart-picker__selections">
            <span className="cart-picker__selections-label cart-picker__label">
              Вы выбрали:
            </span>
            <ul className="cart-picker__selections-list js-cart-picker-selection-list">
              {selectedPackages.map((item) => (
                <li className="cart-picker__selection js-cart-picker-selection-item">
                  <input
                    type="hidden"
                    name="service_code"
                    value={item.billing_service_code}
                  />
                  <span className="cart-picker__selection-name">
                    {item.name}
                  </span>
                  <button
                    className="cart-picker__selection-delete bttn"
                    type="button"
                    onClick={() => {
                      setSelectedPackages((prevState) =>
                        prevState.filter(
                          (elem) =>
                            elem.billing_service_code !==
                            item.billing_service_code
                        )
                      );
                      const remoteServiceCheckbox = document.getElementById(
                        `services_${item.billing_service_code}`
                      );
                      if (remoteServiceCheckbox)
                        remoteServiceCheckbox.checked = false;
                      const remoteCheckbox = document.getElementById(
                        `useful-service_${item.billing_service_code}`
                      );
                      if (remoteCheckbox) remoteServiceCheckbox.checked = false;
                    }}
                  >
                    <HandySvg
                      className="svg-icon"
                      src={iconDeleteCross}
                      width="28"
                      height="28"
                    />
                  </button>
                </li>
              ))}
            </ul>
            <div className="cart-picker__more js-cart-picker-more">Ещё...</div>
          </div>
          <div className="cart-picker__sum">
            <span className="cart-picker__sum-label cart-picker__label">
              Сумма к оплате:
            </span>
            <span className="cart-picker__sum-new">
              {amount}
              <span className="cart-picker__sum-currency">р</span>
            </span>
          </div>
          <div className="cart-picker__continue">
            <button className="cart-picker__continue-btn bttn" type="submit">
              <span className="cart-picker__continue-btn-text">Подключить</span>
              <HandySvg
                className="svg-icon"
                src={iconPointerRight}
                width="19"
                height="10"
              />
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default CartPicker;
